import React, { FC } from 'react'

import { useTheme } from '@mui/material'
import { ToastContainer } from 'react-toastify'

import { useThemeMode } from '../../theme/ThemeModeContext'
import { useJoyride } from '../Joyride/JoyrideProvider'
import { LoaderOverlay } from '../LoaderOverlay'

import { Portal } from './Portal'

export const Portals: FC = () => {
  const { palette } = useTheme()
  const { run } = useJoyride()
  const { resolvedMode } = useThemeMode()

  return (
    <>
      <Portal componentName="toaster">
        {!run && (
          <ToastContainer
            theme={resolvedMode === 'dark' ? 'dark' : 'light'}
            style={{
              paddingTop: 'var(--safe-top)',
            }}
            toastStyle={{
              backgroundColor: palette.background.paper,
            }}
          />
        )}
      </Portal>
      <Portal componentName="loader">
        <LoaderOverlay />
      </Portal>
    </>
  )
}
